/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_Word1Inputs */

const en_wc_vs_who_word1 = /** @type {(inputs: Wc_Vs_Who_Word1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`co-author documents live with a team in Microsoft 365`)
};

/**
* | output |
* | --- |
* | "co-author documents live with a team in Microsoft 365" |
*
* @param {Wc_Vs_Who_Word1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_word1 = /** @type {((inputs?: Wc_Vs_Who_Word1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_Word1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_word1(inputs)
});
export { wc_vs_who_word1 as "wc.vs.who_word1" }